import { useDisclosure } from '@mantine/hooks';
import { IconShirt } from '@tabler/icons-react';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getStyle } from 'services/styleService';
import ResolverImage from '../resolverImage/ResolverImage';
import { logger } from 'utils/logger';
import { getClientLabel, getCompany, getStatusColor, getStyleStatusColor } from 'utils/helper';
import { StyleSwatch } from '..';

const { Popover, Text, Group, Button, createStyles, Box, Badge } = require('@mantine/core');

const useStyles = createStyles((theme) => ({
    card: {
        //   margin:-theme.spacing.md,
        padding: 0,
        position: 'relative',
    },

    imageSection: {
        padding: theme.spacing.md,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderBottom: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]}`,
    },

    label: {
        marginBottom: theme.spacing.xs,
        lineHeight: 1,
        fontWeight: 700,
        fontSize: theme.fontSizes.xs,
        //   letterSpacing: -0.25),
        textTransform: 'uppercase',
    },

    section: {
        paddingTop: theme.spacing.md,
        paddingBottom: theme.spacing.md,
        borderTop: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]}`,
        margin: 0,
        width: '100%',
    },

    icon: {
        color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[5],
    },
}));

const SeasonStylePopover = (props) => {
    const [opened, { close, open }] = useDisclosure(false);
    const [data, setData] = useState();
    const { classes } = useStyles();
    const popRef = useRef();
    const doClose = useRef(true);
    const navigate = useNavigate();
    const company = getCompany(props.aggData);
    useEffect(() => {
        if (opened) {
            logger.log(props.data, data);
            // For season style data, we don't need to fetch additional style info
            // Just use the provided data directly
            setData(props.data);
        }
    }, [opened, props.data]);

    const mouseHandler = (e) => {
        setTimeout(() => {
            if (doClose.current) {
                close();
                doClose.current = true;
            }
        }, 200);
    };

    const showDetails = () => {
        // Navigate to season details instead of style details for season data
        navigate(`/seasons/${props.data.seasonPart}`);
        if (props.onShowDetails) {
            props.onShowDetails();
        }
    };

    return (
        <Popover withinPortal={true} width={300} position='bottom-end' withArrow shadow='md' opened={opened}>
            <Popover.Target>
                <div ref={popRef} onMouseEnter={open} onMouseLeave={(e) => mouseHandler(e)}>
                    {props.children}
                </div>
            </Popover.Target>

            <Popover.Dropdown sx={{ pointerEvents: 'initial' }}>
                {props.data ? (
                    <Box
                        className={classes.card}
                        style={{ padding: 0 }}
                        onMouseLeave={() => {
                            close();
                            doClose.current = true;
                        }}
                        onMouseEnter={() => {
                            open();
                            doClose.current = false;
                        }}>
                        <Group position='apart'>
                            <div>
                                <Text fw={500}>{data?.instructions?.Name || data?.name}</Text>
                                {/* <Text color='dimmed' size={'sm'} lineClamp={2}>
                                    {data?.id}
                                </Text> */}
                                <Text color='dimmed' size={'xs'}>
                                    Style: {data?.stylenumber}
                                </Text>
                            </div>
                            {/* <Badge color={getStyleStatusColor(data?.status)} variant="light" >{data?.status || 'Pending'}</Badge> */}
                        </Group>

                        <Box className={classes.section} mt='md'>
                            <Group>
                                <div>
                                    <Text size='sm' c='dimmed' className={classes.label}>
                                        DEPARTMENT
                                    </Text>
                                    <Text size='sm' fw={500}>
                                        {data?.instructions?.departmentStr || data?.instructions?.department}
                                    </Text>
                                </div>
                            </Group>
                        </Box>

                        <Box className={classes.section} mt='md'>
                            <Group style={{ width: '100%' }}>
                                <div style={{ width: '100%' }}>
                                    <Text size='sm' c='dimmed' className={classes.label}>
                                        PHOTOGRAPHY
                                    </Text>
                                    <Group position='apart'>
                                        <Text size='xs'>Treatment:</Text>
                                        <Text size='xs'>{data?.instructions?.['Web Photography Treatment'] || 'Not specified'}</Text>
                                    </Group>
                                    <Group position='apart'>
                                        <Text size='xs'>Style:</Text>
                                        <Text size='xs'>{data?.instructions?.['Web Photography Style'] || 'Not specified'}</Text>
                                    </Group>
                                    <Group position='apart'>
                                        <Text size='xs'>Code:</Text>
                                        <Text size='xs'>{data?.instructions?.['Web Photography Code'] || 'Not specified'}</Text>
                                    </Group>
                                </div>
                            </Group>
                        </Box>

                        <Box className={classes.section} mt='md'>
                            <Group style={{ width: '100%' }}>
                                <div style={{ width: '100%' }}>
                                    <Text size='sm' c='dimmed' className={classes.label}>
                                        DETAILS
                                    </Text>
                                    <Group position='apart'>
                                        <Text size='xs'>Season:</Text>
                                        <Text size='xs'>{data?.seasonPart}</Text>
                                    </Group>
                                    <Group position='apart'>
                                        <Text size='xs'>Page:</Text>
                                        <Text size='xs'>{data?.pageNumber}</Text>
                                    </Group>
                                    <Group position='apart'>
                                        <Text size='xs'>GTIN:</Text>
                                        <Text size='xs'>{data?.instructions?.['ODBMS APN (GTIN)'] || 'Not specified'}</Text>
                                    </Group>
                                    <Group position='apart'>
                                        <Text size='xs'>{getClientLabel(company, 'otbDate')}:</Text>
                                        <Text size='xs'>{data?.instructions?.['Web Stock OTB Date'] || 'Not specified'}</Text>
                                    </Group>
                                </div>
                            </Group>
                        </Box>

                        {/* <Box className={classes.section} mt='md'>
                            <Group>
                                <div>
                                    <Text size='sm' c='dimmed' className={classes.label}>
                                        COUNTS
                                    </Text>
                                    <Group spacing={20}>
                                        <div>
                                            <Text size='xs' color='dimmed'>
                                                Styles
                                            </Text>
                                            <Text fw={500} size='sm'>
                                                {data?.styleCount || 0}
                                            </Text>
                                        </div>
                                        <div>
                                            <Text size='xs' color='dimmed'>
                                                Captures
                                            </Text>
                                            <Text fw={500} size='sm'>
                                                {data?.captures?.length || 0}
                                            </Text>
                                        </div>
                                        <div>
                                            <Text size='xs' color='dimmed'>
                                                Assets
                                            </Text>
                                            <Text fw={500} size='sm'>
                                                {data?.assets?.length || 0}
                                            </Text>
                                        </div>
                                        <div>
                                            <Text size='xs' color='dimmed'>
                                                Channels
                                            </Text>
                                            <Text fw={500} size='sm'>
                                                {data?.channels?.length || 0}
                                            </Text>
                                        </div>
                                    </Group>
                                </div>
                            </Group>
                        </Box> */}

                        {/* <Box className={classes.section}>
                            <Group position='apart'>
                                <div>
                                    <Text size='xs' color='dimmed'>
                                        Size Count
                                    </Text>
                                    <Text weight={500} size='sm'>
                                        {data?.sizeCount}
                                    </Text>
                                </div>
                                <div>
                                    <Text size='xs' color='dimmed'>
                                        Style Count
                                    </Text>
                                    <Text weight={500} size='sm'>
                                        {data?.styleCount}
                                    </Text>
                                </div>
                                <div>
                                    <Text size='xs' color='dimmed'>
                                        Colour Count
                                    </Text>
                                    <Text weight={500} size='sm'>
                                        {data?.colourCount}
                                    </Text>
                                </div>
                            </Group>
                        </Box> */}
                        <Box className={classes.section}>
                            <Group spacing={30}>
                                <Button style={{ flex: 1 }} onClick={showDetails}>
                                    View Details
                                </Button>
                            </Group>
                        </Box>
                    </Box>
                ) : (
                    <Box>
                        <Text size={'sm'} color='dimmed'>
                            There is no style information available
                        </Text>
                    </Box>
                )}
            </Popover.Dropdown>
        </Popover>
    );
};

export default SeasonStylePopover;
